/*** IMPORTS FROM imports-loader ***/
var define = false;

if (typeof window !== "undefined") {
    module.exports = window;
} else if (typeof global !== "undefined") {
    module.exports = global;
} else if (typeof self !== "undefined"){
    module.exports = self;
} else {
    module.exports = {};
}




//////////////////
// WEBPACK FOOTER
// ./node_modules/global/window.js
// module id = 34
// module chunks = 0